export enum CompanyStatus {
  Churned = -1,
  Trial = 0,
  Customer = 1,
  Kamae = 2,
  Starter = 3,
}
